import { forwardRef, useEffect, useState } from 'react';
import { Loader, Popover, Whisper } from 'rsuite';

const PopoverWithLoader = forwardRef<any, any>(
  ({ content, loading, ...props }: any, ref) => {
    return (
      <Popover ref={ref} {...props}>
        {loading ? <Loader content="Loading..." /> : <div>{content}</div>}
      </Popover>
    );
  }
);

interface IProps {
  placement?: any;
  loading?: boolean;
  children?: any;
  content?: any;
  trigger?: any;
}

export const CustomTooltip = ({
  placement,
  loading,
  children,
  content,
  trigger
}: IProps) => (
  <Whisper
    trigger={trigger}
    placement={placement}
    controlId={`control-id-${placement}`}
    speaker={<PopoverWithLoader loading={loading} content={content} />}
  >
    {children}
  </Whisper>
);
